import { ERASE_ACTION_BUFFER_SUCCESS, SET_ACTION_BUFFER_SUCCESS } from './constants';

let bufferObj = {
    saveAction: false,
    actionBuff: []
};

/**
 *
 * @param key
 * @param state
 * @param elm
 * @returns {*[]}
 */
const doTypeSection = ( { key, state, elm } ) => {
    let i = 0;
    while ( i < state.actionBuff.length ) {
        if ( state.actionBuff[ i ][ key ]?.content?.typeId === elm.actionBuff[ 0 ][ key ]?.content?.typeId ) {
            state.actionBuff[ i ][ key ] = { ...elm.actionBuff[ 0 ][ key ] };
            return [ ...state.actionBuff ];

        }
        i++;
    }
    return [ ...state.actionBuff, ...elm.actionBuff ];
};

/**
 *
 * @param key
 * @param state
 * @param elm
 * @returns {*[]}
 */
const doSettingsSection = ( { key, state, elm } ) => {
    let i = 0;
    while ( i < state.actionBuff.length ) {
        if ( state.actionBuff[ i ].hasOwnProperty( key ) ) {
            const theKey = Object.keys( elm.actionBuff[ 0 ][ key ]?.content )[ 0 ];
            let constent = state.actionBuff[ i ][ key ]?.content;
            if ( constent.hasOwnProperty( theKey ) ) {
                for ( let objKey in constent ) {
                    if ( objKey === theKey ) {
                        constent[ objKey ] = elm.actionBuff[ 0 ][ key ]?.content[ objKey ];
                        return [ ...state.actionBuff ];
                    }
                }
            }
        }
        i++;
    }
    return [ ...state.actionBuff, ...elm.actionBuff ];
};
/**
 *
 *
 * @param key
 * @param state
 * @param elm
 * @returns {*[]}
 */

const checkTypeSettings = ( type ) => {
    const typeArr = ['max_points', 'time_limit',  'points_reduction' ];
    return typeArr.some(elm => elm===type);
};

const checkTypeQuestion = ( type ) => {
    const typeArr = ['text', 'checkbox', 'text_in_order', 'text_poll', 'free_text', 'image', 'scale'];
    return typeArr.some(elm => elm===type);
};

const doQuestion = ( { key, state, elm } ) => {
    let i = 0;
    while ( i < state.actionBuff.length ) {
        if ( state.actionBuff[ i ][ key ]?.id === elm.actionBuff[ 0 ][ key ]?.id ){

            if( state.actionBuff[ i ][ key ]?.type ===  elm.actionBuff[ 0 ][ key ]?.type &&
                !checkTypeQuestion(state.actionBuff[ i ][ key ]?.type) && !checkTypeQuestion(elm.actionBuff[ 0 ][ key ]?.type)){

                state.actionBuff[ i ][ key ].content = elm.actionBuff[ 0 ][ key ].content;

                return [ ...state.actionBuff ];
            } else
            if( state.actionBuff[ i ][ key ]?.type ===  elm.actionBuff[ 0 ][ key ]?.type && checkTypeQuestion(state.actionBuff[ i ][ key ]?.type) && checkTypeQuestion(elm.actionBuff[ 0 ][ key ]?.type)){
                state.actionBuff[ i ][ key ] = { ...elm.actionBuff[ 0 ][ key ] };
                return [ ...state.actionBuff ];
            } else if( !checkTypeSettings(state.actionBuff[ i ][ key ]?.type) &&
                checkTypeSettings(elm.actionBuff[ 0 ][ key ]?.type) &&
                !checkTypeQuestion(state.actionBuff[ i ][ key ]?.type) &&
                !checkTypeQuestion(elm.actionBuff[ 0 ][ key ]?.type)){
                return [ ...state.actionBuff, ...elm.actionBuff ];
            }

        }
        i++;
    }
    return [ ...state.actionBuff, ...elm.actionBuff ];
};

/**
 *
 * @param key
 * @param state
 * @param elm
 * @returns {*[]}
 */
const doAnswer = ( { key, state, elm } ) => {
    let i = 0;
    while ( i < state.actionBuff.length ) {
        if ( state.actionBuff[ i ][ key ]?.answerId === elm.actionBuff[ 0 ][ key ]?.answerId ) {
            state.actionBuff[ i ][ key ] = { ...elm.actionBuff[ 0 ][ key ] };
            return [ ...state.actionBuff ];
        }
        i++;
    }
    return [ ...state.actionBuff, ...elm.actionBuff ];
};

/**
 * 
 * @param key
 * @param state
 * @param elm
 * @returns {*[]}
 */
const doDefault = ( { key, state, elm } ) => {
    let i = 0;
    while ( i < state.actionBuff.length ) {
        if ( state.actionBuff[ i ].hasOwnProperty( key ) ) {
            state.actionBuff[ i ] = elm.actionBuff[ 0 ];
            return [ ...state.actionBuff ];
        }
        i++;
    }
};

/**
 *
 * @param state
 * @param elm
 * @returns {[]|*[]}
 */
const addElmToState = ( state, elm ) => {
    let actionBuff = [];

    if ( state.actionBuff.length > 0 ) {

        try {
            if ( typeof elm.actionBuff[ 0 ] === 'undefined' || typeof Object.keys( elm.actionBuff[ 0 ] ) === 'undefined' ) {
                throw new Error( 'Object.keys(elm.actionBuff[0])[0] is undefined' );
            }
            const key = Object.keys( elm.actionBuff[ 0 ] )[ 0 ];
            const ifThereIs = state.actionBuff.findIndex( ( elm ) => {
                return Object.keys( elm )[ 0 ] === key;
            } );

            if ( ifThereIs === -1 ) {
                actionBuff = [ ...state.actionBuff, ...elm.actionBuff ];
            } else {
                const key = Object.keys( elm.actionBuff[ 0 ] )[ 0 ];
                if ( 'updateType' === key ) {
                    actionBuff = doTypeSection( { key, state, elm } );
                } else if ( 'updateQuizResultSettings' === key || 'updateQuizRegistrationSettings' === key ) {
                    actionBuff = doSettingsSection( { key, state, elm } );
                } else if ( 'updateQuestion' === key || 'updateQuestionFeedback' === key ) {
                    actionBuff = doQuestion( { key, state, elm } );
                } else if ( 'updateAnswer' === key ) {
                    actionBuff = doAnswer( { key, state, elm } );
                } else {
                    actionBuff = doDefault( { key, state, elm } );
                }
            }
        } catch ( e ) {
            return [ ...state.actionBuff ];
        }

    } else {
        actionBuff = elm.hasOwnProperty( 'actionBuff' ) ? [ ...state.actionBuff, ...elm.actionBuff ] : [];
    }

    return actionBuff;
};

/**
 *
 * @param state
 * @param action
 */
const actionBuffer = ( state = bufferObj, action ) => {
    switch ( action.type ) {
        case SET_ACTION_BUFFER_SUCCESS : {
            let actionBuff;
            if ( typeof action.obj.obj.actionBuff === 'undefined' ) {
                return { ...state, saveAction: action.obj.obj.saveAction };
            } else {
                actionBuff = addElmToState( state, action.obj.obj );
                return { ...state, actionBuff: actionBuff, saveAction: action.obj.obj.saveAction };
            }
        }

        case ERASE_ACTION_BUFFER_SUCCESS: {
            bufferObj = { ...state, actionBuff: [], saveAction: false };
            return bufferObj;
        }

        default:
            return state;
    }
};

export { actionBuffer };